import { Button, ButtonProps, Paragraph, RadioCardGroup } from '@purpur/library';
import styled from 'styled-components';

import {
    getPurpurBorder,
    getPurpurColor,
    getPurpurSpacing,
    getPurpurTypography,
} from '@telialt/common-theme/src/purpurSelectors';

import { OpenGiftDetailsModalButton } from './OpenGiftDetailsModalButton';

export const GiftTitle = styled(Paragraph).attrs({ variant: 'paragraph-100-bold' })`
    margin-bottom: ${getPurpurSpacing('50')};
`;

export const GiftPrice = styled.span`
    font-size: ${getPurpurTypography('scale100')};
    line-height: 1.5;
`;

export const GiftPriceOld = styled(GiftPrice)`
    padding-left: ${getPurpurSpacing('100')};
    text-decoration: line-through;
`;

export const LocalCode = styled.div`
    margin-top: ${getPurpurSpacing('150')};
    user-select: all;
    font-size: ${getPurpurTypography('scale75')};
    color: ${getPurpurColor('textInteractiveSelected')};
    word-break: break-all;
    width: fit-content;
`;

export const ReadOnlyCardGroup = styled.ul`
    all: unset;
    display: flex;
    flex-direction: column;
    gap: ${getPurpurSpacing('200')};
`;

export const ReadOnlyCard = styled.li`
    all: unset;
    background-color: ${getPurpurColor('backgroundPrimary')};
    border-radius: ${getPurpurBorder('radiusMd')};
    box-shadow: ${getPurpurColor('borderInteractiveSubtle')} 0 0 0 ${getPurpurBorder('widthXs')} inset;

    display: grid;
    grid-template-areas:
        'symbol body image'
        '. extra extra';
    grid-template-columns: ${getPurpurSpacing('300')} auto ${getPurpurSpacing('800')};
    column-gap: ${getPurpurSpacing('150')};
    row-gap: ${getPurpurSpacing('200')};
    padding: ${getPurpurSpacing('200')};
`;

export const Body = styled.div`
    grid-area: body;
    padding-right: ${getPurpurSpacing('50')};
`;

export const GiftSymbol = styled.span`
    grid-area: symbol;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
    height: ${getPurpurSpacing('300')};
    width: ${getPurpurSpacing('300')};
    border-radius: ${getPurpurBorder('radiusXs')};
    box-shadow: ${getPurpurColor('borderWeak')} 0 0 0 ${getPurpurBorder('widthXs')} inset;
    background-color: ${getPurpurColor('backgroundInteractiveDisabled')};
    color: ${getPurpurColor('textWeak')};
`;

export const Extra = styled.div`
    grid-area: extra;
`;

export const Image = styled.img`
    width: 100%;
    height: 100%;
    object-fit: contain;
`;

export const ImageWithOffset = styled(Image)`
    padding: ${getPurpurSpacing('200')} ${getPurpurSpacing('200')} ${getPurpurSpacing('200')} 0;
`;

export const StartTextButton = styled(Button).attrs<Partial<ButtonProps>>({ variant: 'text' })`
    margin-right: auto;
`;

export const OpenGiftDetailsButtonWithOffset = styled(OpenGiftDetailsModalButton)`
    margin-left: calc(${getPurpurSpacing('300')} + ${getPurpurSpacing('150')} + ${getPurpurSpacing('200')});
    margin-bottom: ${getPurpurSpacing('150')};
`;

const radioCard = `button[role='radio']`;
export const RadioGiftCardGroup = styled(RadioCardGroup)`
    ${radioCard}[aria-checked='true'] + ${OpenGiftDetailsButtonWithOffset} {
        display: inherit;
    }
    ${radioCard}:not([aria-checked='true']) + ${OpenGiftDetailsButtonWithOffset} {
        display: none;
    }
`;
